/**
 * validate function
 */

export function isvalidUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}


/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[3456789]\d{9}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /\d{3}-\d{8}|\d{4}-\d{7}/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 正整数正则
 * @param {*} s
 */
export function isNumber (s) {
  return /^\+?[1-9][0-9]*$/.test(s)
}


/**
 * 负整数正则
 * @param {*} s
 */
export function isNeg (s) {
  return /^-\d+$/.test(s)
}


/**
 * 整数正则
 * @param {*} s
 */
export function isInt (s) {
  return /^-?\d+$/.test(s)
}


/**
 * 正数正则 可以是整数也可以是浮点数
 * @param {*} s
 */
export function isPosFloat (s) {
  return /^\d*\.?\d+$/.test(s)
}


/**
 * 负数正则 可以是整数也可以是浮点数
 * @param {*} s
 */
export function isNegFloat (s) {
  return /^-\d*\.?\d+$/.test(s)
}


/**
 * 数字正则 可以是整数也可以是浮点数
 * @param {*} s
 */
export function isNumFloat (s) {
  return /^-?\d*\.?\d+$/.test(s)
}


/**
 * 包含中文正则
 * @param {*} s
 */
export function isCN (s) {
  return /[\u4E00-\u9FA5]/.test(s)
}


/**
 * 非空
 * @param {*} s
 */
export function isEmpty (s) {
  return /^\s*$/g.test(s) || s == null || s == ""
}


/**
 * 身份证号
 * @param {*} s
 */
export function isCardid (s) {
  return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(s);
}


/**
 * 用户名正则，帐号是否合法(字母开头，允许5-16字节，允许字母数字下划线组合
 * @param {*} s
 */
export function isUsername (s) {
  return /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/.test(s);
}

/**
 * 4位验证码
 * @param {*} s
 */
export function isCode4 (s) {
  return /^\d{4}$/.test(s);
}

/**
 * 密码正则，密码至少包含 数字，长度6-18
 * @param {*} s
 */
export function isPassword0 (s) {
  return /^[0-9A-Za-z-*/+.~!@#$%]{6,18}$/.test(s);
}

/**
 * 密码正则，密码至少包含 数字和英文，长度6-18
 * @param {*} s
 */
export function isPassword1 (s) {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/.test(s);
}


/**
 * 密码正则2，密码包含 数字,英文,字符中的两种以上，长度6-18
 * @param {*} s
 */
export function isPassword2 (s) {
  return /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,18}$/.test(s);
}


/**
 * 密码正则3，至少包含数字跟字母，可以有字符
 * @param {*} s
 */
export function isPassword3 (s) {
  return /(?=.*([a-zA-Z].*))(?=.*[0-9].*)[a-zA-Z0-9-*/+.~!@#$%^&*()]{6,18}$/.test(s);
}




/**
 * 中文姓名，
 * @param {*} s
 */
export function isCNUsername (s) {
  return /^([\u4e00-\u9fa5·]{2,16})$/.test(s);
}


/**
 * 英文姓名
 * @param {*} s
 */
export function isENUsername (s) {
  return /(^[a-zA-Z]{1}[a-zA-Z\s]{0,20}[a-zA-Z]{1}$)/.test(s);
}

/**
 * 是不是安卓
 * @param {*} str 
 */
export function isAndroid() {
  var u = navigator.userAgent;
  var isA = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  return isA
}

/**
 * 是不是IOS
 * @param {*} str 
 */
export function isIOS() {
  var u = navigator.userAgent;
  var isI = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  return isI
}